module.exports = __webpack_public_path__ + "assets/images/19c025a8f7cfd363e59d4406cadb29f6.svg";